module.exports = __webpack_public_path__ + "static/media/ellipse.aa1c16b8.svg";